<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        created() {
            this.loadIlog(() => {});
            this.loadBridge(() => {});

            if (location.href.indexOf('zax') > -1) {
                _zax.use('vconsole', () => {
                    let vConsole = new VConsole()
                    // console.log('vconsole loaded')
                })
            }

        },
        methods: {

            loadIlog(cb) {
                _zax.use(['ilog'], () => {
                    cb && cb();
                });
            },

            loadBridge(cb) {
                if (_zax.device.app) {
                    _zax.use(['bridge'], () => {
                        cb && cb();
                    });
                }
            },

        }
    };
</script>


// WEBPACK FOOTER //
// src/App.vue